import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "reactstrap"

function IdleLogoutAlert(props: IdleLogoutAlertProps){
    const [timer, setTimer] = useState(props.autoCloseTimer / 1000);
    const { t } = useTranslation();
    let myInterval: ReturnType<typeof setTimeout>;

    const resetTimerAction = () => {
        clearInterval(myInterval);
        props.userCloseAction()
      }

    useEffect(() => {
      
        setTimeout(async () => {
            myInterval = setInterval(() => setTimer(timer - 1), 1000);
            if(timer < 1){
                clearInterval(myInterval);
                props.autoCloseAction();
            }
        }, 100)
        
        return function clear() {
          clearInterval(myInterval);
        };
      }, [timer]);
      
    return (
        <Alert 
            isOpen={props.isOpen}
            color={'info'}
            className="px-5 mb-0 text-center position-absolute top-50 start-50 translate-middle"
            style={{zIndex: "9"}}
          >
            <i className="mdi mdi-clock-time-three d-block display-4 mt-2 mb-3 text-dark "></i>
            <h5 className="text-dark">{ t("Are you still there?") }</h5>
            <p className="text-dark">If not, we'll close this session in: { timer } seconds</p>
            <button className="btn btn-dark" onClick={() => resetTimerAction() }>I'm Here</button>
        </Alert>
    )
}

interface IdleLogoutAlertProps {
    isOpen: boolean;
    autoCloseTimer: number;
    autoCloseAction: () => void;
    userCloseAction: () => void;
}

IdleLogoutAlert.defaulProps = {
    isOpen: false,
    autoCloseTimer: 60,
}

export default IdleLogoutAlert